/**
 * @param {jQuery} $ jQuery object.
 */
(function( $ ) {

	/**
	 * Stick/unstick the Recent Posts grid
	 *
	 * @since 1.0.0
	 */
	var recentPostsSlider = function() {
		var $carousel = $( '#recent-posts' );

		if ( 0 === $carousel.length ) {
			return;
		}

		var windowWidth = $(window).width();

		if ( windowWidth <= '768' ) {
			if ( ! $carousel.hasClass( 'slick-initialized' ) ) {
				$carousel.slick({
					slidesToShow: 1,
					infinite: false,
					arrows: false,
					dots: true,
					focusOnSelect: true,
					centerMode: true,
					initialSlide: 0
				});
			}
		} else {
			if ( $carousel.hasClass( 'slick-initialized' ) ) {
				$carousel.slick( 'unslick' );
			}
		} 
	};

	/**
	 * Parallax effect on Themes Overview.
	 *
	 * @since 1.0.0
	 */
	var themesOverview = function() {
		var $themesOverview = $( '#themes-overview' );

		if ( 0 === $themesOverview.length ) {
			return;
		}

		var themesOffset = $themesOverview.offset();

		var themes = new Choreographer({
			animations: [
				{
					range: [ themesOffset.top - 500, themesOffset.top + 500 ],
					selector: '.themes-overview__front',
					type: 'scale',
					style: 'transform:translateY',
					from: 0,
					to: 15,
					unit: 'px'
				},
				{
					range: [ themesOffset.top - 500, themesOffset.top + 500 ],
					selector: '.themes-overview__back',
					type: 'scale',
					style: 'transform:translateY',
					from: 0,
					to: -15,
					unit: 'px'
				}
			]
		});

		window.addEventListener( 'scroll', function() {
			themes.runAnimationsAt( window.pageYOffset );
		});
	};

	/**
	 * Parallax effect on Plugins Overview.
	 *
	 * @since 1.0.0
	 */
	var pluginsOverview = function() {
		var $pluginsOverview = $( '#plugins-overview' );

		if ( 0 === $pluginsOverview.length ) {
			return;
		}

		var i = 0;
		var pluginsOffset = $pluginsOverview.offset();
		var ans = [];

		for( i = 5; i <= 7; i++ ) {
			ans.push({
				range: [ pluginsOffset.top - 500, pluginsOffset.top + 100 ],
				selector: '.plugins-overview__' + i,
				type: 'scale',
				style: 'transform:translateY',
				from: 0,
				to: ( i * 2 ),
				unit: 'px'
			});
		}

		for( i = 0; i <= 4; i++ ) {
			ans.push({
				range: [ pluginsOffset.top - 500, pluginsOffset.top + 100 ],
				selector: '.plugins-overview__' + i,
				type: 'scale',
				style: 'transform:translateY',
				from: 0,
				to: ( i * 5 ) * -1,
				unit: 'px'
			});
		}

		var plugins = new Choreographer({
			animations: ans
		});

		window.addEventListener( 'scroll', function() {
			plugins.runAnimationsAt( window.pageYOffset );
		});
	};

	/**
	 * Bind to the DOM
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {

		if ( 0 === $( 'body.home' ).length ) {
			return;
		}

		/**
		 * Blog Posts
		 */
		recentPostsSlider();

		/**
		 * Overview
		 */
		themesOverview();
		pluginsOverview();

		/**
		 * Testimonials
		 */

		// main slider
		$( '.testimonials__slider' ).slick({
			asNavFor: '.testimonials__slider-nav',
			fade: true,
			cssEase: 'linear',
			arrows: false,
			dots: true
		});
		
		// logo navigation on large devices
		$( '.testimonials__slider-nav' ).slick({
			asNavFor: '.testimonials__slider',
			slidesToShow: 4,
			dots: false,
			focusOnSelect: true,
			arrows: false,
			variableWidth: true,
			centerMode: true
		});
	});

	/**
	 * Bind to window resize.
	 *
	 * @since 1.0.0
	 */
	$(window).resize(function() {
		recentPostsSlider();
	});

})( jQuery );
